var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.item !== '' && _vm.item !== null)?[_vm._t("default")]:_c('v-icon',{attrs:{"dense":"","color":"secondary"}},[_vm._v(_vm._s(_vm.icons.mdiPencilOutline))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }